import { ready } from "~/core";

ready("subNav", ".subNav", (subNav) => {
  const navToggle = subNav.querySelector(".subNav__toggle");
  const dropdowns = subNav.querySelectorAll(".subNav__dropdown");

  const toggleMainNav = (e) => {
    subNav.classList.toggle("opened");

    if (subNav.classList.contains("opened")) {
      navToggle.setAttribute("aria-expanded", "true");
      navToggle.setAttribute("aria-label", "Close sub navigation menu");
      navToggle.textContent = "Close";
    } else if (!subNav.classList.contains("opened")) {
      navToggle.setAttribute("aria-expanded", "false");
      navToggle.setAttribute("aria-label", "Open sub navigation menu");
      navToggle.textContent = "Menu";
    }
  };

  const toggleDropdowns = (e) => {
    const parent = e.target.parentElement;
    parent.classList.toggle("opened");

    if (parent.classList.contains("opened")) {
      e.target.setAttribute("aria-expanded", "true");
      e.target.setAttribute("aria-label", "Close dropdown navigation items");
    } else if (!parent.classList.contains("opened")) {
      e.target.setAttribute("aria-expanded", "false");
      e.target.setAttribute("aria-label", "Open dropdown navigation items");
    }
  };

  const init = () => {
    navToggle.addEventListener("click", toggleMainNav);
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("click", toggleDropdowns);
    });
  };

  init();
});
